import React from "react";
import ButtonLink from "../../../components/elements/ButtonLink";

const CourseCard = ({ course, cohortLoading, cohortData }) => {
  return (
    <div className="flex flex-wrap items-center bg-white rounded-lg md:px-4 pt-0 lg:pt-4 pb-4">
      <div className="w-full lg:w-8/12 px-0 lg:px-8 mb-4">
        <div className="w-full lg:w-3/12 mb-6 lg:hidden">
          <img
            src={course.courseImage}
            width="100%"
            alt=""
            className="object-cover h-52 md:h-72 bg-top rounded-lg"
          />
        </div>
        <div className="px-6 lg:px-0">
          <div className="mt-6 mb-4 lg:mt-6 lg:mb-6 text-xs leading-5 flex flex-wrap space-x-2">
            {course.courseTags?.[0] && (
              <div className="tag-primary px-2 rounded-sm">
                <p>{course.courseTags?.[0]}</p>
              </div>
            )}

            {course.courseTags?.[1] && (
              <div className="tag-secondary px-2 rounded-sm">
                <p>{course.courseTags?.[1]}</p>
              </div>
            )}
          </div>

          <h4 className="text-default pb-4 lg:pb-6 font-mono text-base md:text-lg lg:text-xl xl:text-2xl font-semibold">
            {course.courseName}
          </h4>

          <p className="text-default text-sm md:text-sm-15 lg:text-base lg:leading-7 pb-4 w-full lg:w-10/12">
            {course.courseDescription}
          </p>

          <p className="mt-2 mb-6 flex items-center text-xs lg:text-sm">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.99992 14.6666C4.31792 14.6666 1.33325 11.6819 1.33325 7.99992C1.33325 4.31792 4.31792 1.33325 7.99992 1.33325C11.6819 1.33325 14.6666 4.31792 14.6666 7.99992C14.6666 11.6819 11.6819 14.6666 7.99992 14.6666ZM7.99992 13.3333C9.41441 13.3333 10.771 12.7713 11.7712 11.7712C12.7713 10.771 13.3333 9.41441 13.3333 7.99992C13.3333 6.58543 12.7713 5.22888 11.7712 4.22868C10.771 3.22849 9.41441 2.66659 7.99992 2.66659C6.58543 2.66659 5.22888 3.22849 4.22868 4.22868C3.22849 5.22888 2.66659 6.58543 2.66659 7.99992C2.66659 9.41441 3.22849 10.771 4.22868 11.7712C5.22888 12.7713 6.58543 13.3333 7.99992 13.3333ZM8.66659 7.99992H11.3333V9.33325H7.33325V4.66659H8.66659V7.99992Z"
                fill="black"
              />
            </svg>
            <span className="pl-2 text-gray">{course.courseDuration}</span>
          </p>

          <p className="mb-6 lg:mb-10 text-primary text-sm md:text-sm-15 lg:text-base">
            Next class starts:{" "}
            <strong>
              {cohortLoading
                ? "Loading..."
                : cohortData?.date || "Not Specified"}
            </strong>
          </p>

          <div className="">
            <ButtonLink
              title={"Learn More"}
              url={`/courses${course.courseUrl}`}
            />
          </div>
        </div>
      </div>
      <div className="w-full lg:w-4/12 hidden lg:block">
        <img
          src={course.courseImage}
          width="100%"
          alt=""
          className="object-cover rounded-lg"
        />
      </div>
    </div>
  );
};

export default CourseCard;
